import React from "react";
import { Table, Space, Button, Tag } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { ListComponent, BaseListComponentProps } from "../BaseComponent";
import IIntegration from "../../interfaces/IIntegration";
import { SearchRequest } from "../../services/api/interfaces/ApiRequest";
import {
  DisconnectRequest,
  SetMainRequest,
} from "../../services/integration/interfaces/ApiRequest";
import { Pagination } from "components/Pagination";

type IntegrationListProps = BaseListComponentProps & {
  integrations: any;
  pagination: any;
  loading: boolean;

  history: any;
  searchOptions: any;

  loadIntegrations: (args: SearchRequest) => void;
  disconnectIntegration: (args: DisconnectRequest) => Promise<any>;
  setMainIntegration: (args: SetMainRequest) => Promise<any>;
  editItem: any;
};

export default class IntegrationDefinitionsList extends ListComponent<IntegrationListProps> {
  static defaultProps = {
    loading: false,
  };

  state = {
    removed: [] as string[],
  };

  tableColumns = [
    {
      title: "UUID",
      dataIndex: "uuid",
      key: "uuid",
    },
    {
      title: "Partner",
      dataIndex: "partner_key",
      key: "partner_key",
      responsive: ["md"] as any,
    },
    {
      title: "Shelter",
      dataIndex: ["shelter", "name"],
      key: "shelter",
      responsive: ["md"] as any,
    },
    {
      title: "Partner",
      dataIndex: "partner_key",
      key: "partner_key",
      responsive: ["md"] as any,
    },
    {
      title: "Path",
      dataIndex: "path",
      key: "path",
      responsive: ["md"] as any,
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      responsive: ["md"] as any,
    },
    {
      title: "Condition",
      dataIndex: "condition",
      key: "condition",
      responsive: ["md"] as any,
    },
    {
      title: "Value",
      dataIndex: "value",
      key: "value",
      responsive: ["md"] as any,
    },
    {
      title: "Priority",
      dataIndex: "priority",
      key: "priority",
      responsive: ["md"] as any,
    },
    {
      title: "Active",
      active: "active",
      key: "active",
      responsive: ["md"] as any,
      render: (text: string, record: IIntegration) => {
        return (
          <Tag color={record.active ? "green" : "geekblue"}>
            {record.active ? "Yes" : "No"}
          </Tag>
        );
      },
    },
    {
      title: "Global",
      active: "global",
      key: "global",
      responsive: ["md"] as any,
      render: (text: string, record: IIntegration) => {
        return (
          <Tag color={(record as any)?.global ? "green" : "geekblue"}>
            {(record as any)?.global ? "Yes" : "No"}
          </Tag>
        );
      },
    },
    {
      title: "Actions",
      key: "action",
      align: "right",
      render: (text: string, record: any) => (
        <Space size="middle">
          <Button
            type="dashed"
            shape="round"
            onClick={() => {
              this.props.editItem(record);
            }}
            icon={<EditOutlined />}
          />
        </Space>
      ),
    },
  ] as any;

  public load() {
    this.searchOptions = {
      search: {
        ...this.props.searchOptions.search,
      },
      options: {
        ...this.props.searchOptions.options,
      },
    };

    this.props.loadIntegrations(this.searchOptions);
  }

  render() {
    const { loading, pagination, integrations, loadIntegrations } = this.props;
    const { removed } = this.state;

    const data = integrations?.filter((v) => !removed.includes(v.uuid));
    return (
      <>
        <Table
          loading={loading}
          rowKey="uuid"
          columns={this.tableColumns}
          pagination={false}
          dataSource={data}
          onChange={(pagination: any, filters: any, sorter: any) =>
            this.handleTableChange(pagination, sorter, loadIntegrations)
          }
        />
        <Pagination
          loading={loading}
          current={pagination?.page}
          pageSize={pagination?.limit}
          length={data?.length}
          onChange={(pagination) =>
            this.handleTableChange(pagination, undefined, loadIntegrations)
          }
        />
      </>
    );
  }
}
